module.exports = __webpack_public_path__ + "img/vertical_6_5_6000.cc33799e.png";